import OfertaSugeridaDto from '../dto/OfertaSugeridaDto';

export default class OfertaSugeridaResource {
  dividaId: number;
  valorTotalDivida: number;
  contratoDivida: string;
  recebeOferta: boolean;
  ofertaId?: number | string;
  quantidadeParcelas: number;
  valorParcela: number;
  valorEntrada: number;
  dataPrimeiroBoleto: Date;
  valorTotal: number;
  possuiEntrada: boolean;
  quantidadeParcelasMaisEntrada: number;
  valorCorrecao: number;
  ofertaCorrigida: boolean;
  logo?: string;

  constructor(resource: OfertaSugeridaDto) {
    this.dividaId = resource.dividaId;
    this.valorTotalDivida = resource.valorTotalDivida;
    this.contratoDivida = resource.contratoDivida;
    this.recebeOferta = resource.recebeOferta;
    this.ofertaId = resource.ofertaId ?? undefined;
    this.quantidadeParcelas = resource.quantidadeParcelas;
    this.valorParcela = resource.valorParcela;
    this.valorEntrada = resource.valorEntrada;
    this.dataPrimeiroBoleto = new Date(resource.dataPrimeiroBoleto);
    this.valorTotal = resource.valorTotal;
    this.possuiEntrada = resource.possuiEntrada;
    this.quantidadeParcelasMaisEntrada = resource.quantidadeParcelasMaisEntrada;
    this.valorCorrecao = resource.valorCorrecao;
    this.ofertaCorrigida = resource.ofertaCorrigida;
    this.logo = resource.logo || undefined;
  }

  get valorDesconto(): number {
    return this.valorTotalDivida - this.valorTotal;
  }

  get percentualDesconto(): number {
    return Math.floor((this.valorDesconto * 100) / this.valorTotalDivida);
  }

  /**
   * Converte OfertaSugeridaResource em um objeto compatível com OfertaResource
   * para uso em componentes que esperam OfertaResource
   */
  converterParaObjetoCompativelComOfertaResource(): {
    id: number | string;
    prioridade: number;
    descricao: string;
    dividaId: number;
    quantidadeParcelas: number;
    valorParcela: number;
    valorEntrada: number;
    dataPrimeiroBoleto: Date;
    valorTotal: number;
    possuiEntrada: boolean;
    quantidadeParcelasMaisEntrada: number;
    valorNegociado: number;
    negociacaoParcial: boolean;
    necessitaDetalhamento: boolean;
    meiosPagamentosDisponiveis: [];
    percentualDesconto: number;
    tipoNegociacao: undefined;
    } {
    return {
      id: this.ofertaId ?? 'sugerida',
      prioridade: 0,
      descricao: '',
      dividaId: this.dividaId,
      quantidadeParcelas: this.quantidadeParcelas,
      valorParcela: this.valorParcela,
      valorEntrada: this.valorEntrada,
      dataPrimeiroBoleto: this.dataPrimeiroBoleto,
      valorTotal: this.valorTotal,
      possuiEntrada: this.possuiEntrada,
      quantidadeParcelasMaisEntrada: this.quantidadeParcelasMaisEntrada,
      valorNegociado: this.valorTotalDivida,
      negociacaoParcial: false,
      necessitaDetalhamento: false,
      meiosPagamentosDisponiveis: [],
      percentualDesconto: this.percentualDesconto,
      tipoNegociacao: undefined,
    };
  }
}
